import { Club, DollarTag, Hashtag, User } from "api";
import { To } from "react-router-dom";

type Entity = User | DollarTag | Hashtag | Club | null | undefined;

export const generateCombinationLink = (items: Array<Entity>): To => {
  const searchParams: Record<string, string> = getSearchParams(items);
  return {
    pathname: "/filter-posts",
    search: new URLSearchParams(searchParams).toString(),
  };
};

const getSearchParams = (items: Array<Entity>) => {
  return items?.reduce(
    (a, c) => ({ ...getSearchParam(c), ...a }),
    {} as Record<string, string>
  );
};

export const getSearchParam = (item: Entity): Record<string, string> => {
  switch (item?.__typename) {
    case "User":
      return { userId: item?.id as string };

    case "Club":
      return { clubId: item?.clubId as string };

    case "DollarTag":
      return {
        dollarId: item?.dollarTagId?.toString(),
      };

    case "Hashtag":
      return { hashTagId: item?.TagId as string };

    default:
      return {};
  }
};
